import type { CSSProperties } from 'react';

const balanceKeyframes = `
  @keyframes balanceDrawLeftToRight {
    0% { stroke-dashoffset: 250; opacity: 0.6; stroke-width: 3.5; }
    40% { stroke-dashoffset: 0; opacity: 1; stroke-width: 4; }
    60% { stroke-dashoffset: 0; opacity: 1; stroke-width: 4; }
    100% { stroke-dashoffset: -250; opacity: 0.6; stroke-width: 3.5; }
  }
  @keyframes balanceDrawRightToLeft {
    0% { stroke-dashoffset: -250; opacity: 0.6; stroke-width: 3.5; }
    40% { stroke-dashoffset: 0; opacity: 1; stroke-width: 4; }
    60% { stroke-dashoffset: 0; opacity: 1; stroke-width: 4; }
    100% { stroke-dashoffset: 250; opacity: 0.6; stroke-width: 3.5; }
  }
`;

export type IconBalanceProps = {
  animated?: boolean;
  height?: number | string;
  style?: CSSProperties;
  width?: number | string;
};

export const IconBalance = ({ animated = false, height = 23, style, width = 24 }: IconBalanceProps) => (
  <>
    {animated ? <style>{balanceKeyframes}</style> : null}
    <svg
      fill="none"
      height={height}
      style={{ filter: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.08))', overflow: 'visible', ...style }}
      viewBox="0 0 84 34"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00024 21.664C2.00024 21.664 8.66691 31.3184 20.7881 31.3184C37.7578 31.3184 45.176 21.2993 59.576 19.2504C76.5457 16.8368 82.0002 31.3184 82.0002 31.3184"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        style={
          animated
            ? {
                animation: 'balanceDrawLeftToRight 2.5s ease-in-out infinite',
                strokeDasharray: 250,
              }
            : undefined
        }
      />
      <path
        d="M2.00024 4.80072C2.00024 4.80072 8.66691 14.4551 20.7881 14.4551C37.7578 14.4551 45.176 4.436 59.576 2.38713C76.5457 -0.0264636 82.0002 9.6279 82.0002 9.6279"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        style={
          animated
            ? {
                animation: 'balanceDrawRightToLeft 2.5s ease-in-out infinite',
                strokeDasharray: 250,
              }
            : undefined
        }
      />
    </svg>
  </>
);
